function t(r, e) {
  return `var(--${r}-${e})`;
}
function n(r, e) {
  return `1px solid ${t(r, e)}`;
}
function o(r, e) {
  return `4px solid ${t(r, e)}`;
}
export {
  n as createBorder,
  t as createColorVariable,
  o as createOutline
};
